import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { CustomOptions, Catalog, Clock } from '@one-thd/sui-icons';
const advantages = [
    {
        icon: () => React.createElement(Clock, null),
        title: 'Faster, Easier Ordering',
        description: 'Save your delivery address and card information for easy, one-step purchasing.',
    },
    {
        icon: () => React.createElement(Catalog, null),
        title: 'Quick Order Review',
        description: 'Review your item selection and delivery dates before placing your order.',
    },
    {
        icon: () => React.createElement(CustomOptions, null),
        title: 'Change Settings Anytime',
        description: 'Adjust your saved address or card information at any time.',
    },
];
export const SetUpInstantCheckout = ({ handleStartSetUp, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-mb-8 2xl:sui-mb-8" },
            React.createElement("div", { className: "sui-pb-2" },
                React.createElement(Typography, { variant: "h2", weight: "display" }, "Save Time with Instant Checkout")),
            React.createElement("div", { className: "sui-pb-8" },
                React.createElement(Typography, null, "Set up your delivery address and payment method to start express shopping.")),
            React.createElement("div", { className: "sui-w-full md:sui-w-1/2 xl:sui-w-1/6" },
                React.createElement(Button, { onClick: handleStartSetUp, fullWidth: true, "data-testid": "get-started-ic-btn" }, "Get Started"))),
        React.createElement("ul", { className: "sui-grid sui-grid-cols-9 sui-gap-5", "data-testid": "advantages" }, advantages.map((item) => (React.createElement("li", { key: item.title, className: "sui-col-span-9 xl:sui-col-span-3" },
            React.createElement("div", { className: "sui-flex sui-items-center sui-gap-2 sui-mb-2" },
                item.icon(),
                React.createElement(Typography, { variant: "h4" }, item.title)),
            React.createElement(Typography, null, item.description)))))));
};
